import styled from 'styled-components';
import { lighten, darken } from 'polished';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #fafafa;
`;

export const ContainerColumn = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  margin-left: 224px;
`;

export const ContainerBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fafafa;
`;

export const ContainerForms = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  min-height: 625px;
  margin-top: 60px;
  margin-bottom: 60px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
  padding: 15px 15px 60px 15px;

  form {
    height: 100%;
  }
`;

export const ContainerInformations = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 50%;
  border-radius: 5px;
  background-color: transparent;
  padding: 0px;

  img {
    width: 18px;
    height: 14px;
    margin-right: 10px;
  }

  text {
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
  }
`;

export const HeaderInformations = styled.div`
  display: flex;
  align-items: center;
  height: 20px;

  img {
    width: 23px;
    height: 23px;
    margin-right: 10px;
  }

  text {
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
  }
`;

export const LineVertical = styled.div`
  width: 2px;
  height: 23px;
  margin-right: 25px;

  background: #6096ba;
`;

export const LineHorizontal = styled.div`
  width: 100%;
  height: 0px;
  margin-top: 20px;

  border: 1px solid #eeeeee;
`;

export const ContainerHeader = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  border-radius: 5px;
  background-color: transparent;
  margin-bottom: 30px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  text {
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #333533;
  }
`;

export const DivForms = styled.div`
  display: flex;
  flex: 1;
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  padding: 0;

`;

export const TransferListDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const TransferInput = styled.ul`
  width: 490px;
  height: 125px;

  background-color: transparent;
  border-radius: 3px;

  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
`

export const TransferItem = styled.li`
  &:hover {
    background: ${darken(0.04, '#ffffff')};
    cursor: pointer;
  }
  &:focus {
    outline: thin dotted;
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
  }
`;

export const TransferButton = styled.button`
  border: none;
  text-align: center;
  border-radius: 3px;
  transition-duration: 0.4s;
  margin: 5px 20px 5px 20px;
  width: 46px;
  height: 30px;
  color: #ffffff;
  background-color: #6096BA;
  border-radius: 3px;

  &:hover {
    background: ${lighten(0.15, '#6096BA')};
    cursor: pointer;
  }
  &:focus {
    outline: thin dotted;
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
  }
`;

export const DivInput = styled.div`
  /* width: 30%; */
  display: flex;
  flex-direction: column;

  @media(max-width: 960px) {
   width: 100%;
    /* border: 1px solid red; */
    
  }

  img {
    width: 55px;
    height: 55px;
  }

  input {
    margin-top: 10px;
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 1rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #ececec;
    background-clip: padding-box;
    border: none;
    border-radius: 3px;
    -webkit-transition: border-color 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;

    &::placeholder {
      color: #afaeae;
    }

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }
  }

  select {
    margin-top: 10px;
    display: block;
    width: 100%;
    padding: 0.8rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: none;
    border-radius: 3px;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
    -webkit-transition: border-color 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }
  }
`;


export const DivInputText = styled.div`
width: 92%;
`

export const Label = styled.text`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  color: #8c8c8c;
`;

export const SubmitButton = styled.button`
  border: none;
  text-align: center;
  border-radius: 3px;
  transition-duration: 0.4s;
  margin-right: 40px;
  width: 197px;
  height: 41px;
  color: #ffffff;
  background-color: #82ce5e;
  box-shadow: 0px 3px 8px rgba(130, 206, 94, 0.4);
  border-radius: 3px;

  &:hover {
    background: ${lighten(0.15, '#82CE5E')};
    cursor: pointer;
  }
  &:focus {
    outline: thin dotted;
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
  }
`;

export const PreviousButton = styled.button`
  border: none;
  text-align: center;
  transition-duration: 0.4s;
  margin-right: 16px;
  width: 162px;
  height: 41px;
  color: #C8C8C8;
  background-color: transparent;
  border: 1.5px solid #C8C8C8;
  border-radius: 3px;

  &:hover {
    background: ${darken(0.05, '#ffffff')};
    cursor: pointer;
  }
  &:focus {
    outline: thin dotted;
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
  }
`;

export const AddButton = styled.button`
  border: none;
  text-align: center;
  border-radius: 3px;
  transition-duration: 0.4s;
  margin-right: 40px;
  width: 184px;
  height: 36px;
  color: #ffffff;
  background-color: #618095;
  box-shadow: 0px 3px 8px rgba(97,128,149, 0.4);
  border-radius: 3px;

  &:hover {
    background: ${lighten(0.15, '#618095')};
    cursor: pointer;
  }
  &:focus {
    outline: thin dotted;
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
  }
`;

export const DarkContainer = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;

  height: 2000px;
  width: 2500px;
`;

export const NextStepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
`;

export const StepText = styled.text`
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  margin-left: 22px;

  color: #618095;
`;

export const NavTab = styled.ul`
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 30px;
  list-style: none;
  border-bottom: 2px solid #618095;

  li {
    display: flex;
    background: #cfdbd5;
    border-radius: 5px 5px 0px 0px;
    color: #fff;
    min-width: 144px;
    max-width: 100%;
    height: 39px;
    margin-left: 10px;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;

    a {
      display: block;
      padding: 0.5rem 1rem;
      text-decoration: none;
      color: #fff;

      &:hover {
        color: #fff;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

export const FourthSection = styled.div`
margin: 20px 0 0 auto;
display: flex;
justify-content: flex-end;
width: 50%;
button {
    width: 250px;
    height: 41px;
    justify-self: flex-end;
    color: #fff;
    border: none;

    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    /* identical to box height */

    background: #82ce5e;
    box-shadow: 0px 3px 8px rgba(130, 206, 94, 0.4);
    border-radius: 3px;

    &:hover {
      cursor: pointer;
      background-color: ${lighten(0.06, '#82ce5e')};
    }

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }
  }

  @media (max-width: 400px) {
    width: 100%;
    button {
      width: 100%;
    }
  }
`

export const ConfirmButton = styled.button`
    width: 100px;
    height: 41px;
    justify-self: flex-end;
    color: #fff;
    border: none;

    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    /* identical to box height */

    background: #82ce5e;
    box-shadow: 0px 3px 8px rgba(130, 206, 94, 0.4);
    border-radius: 3px;

    &:hover {
      cursor: pointer;
      background-color: ${lighten(0.06, '#82ce5e')};
    }

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    
  }
`

export const DenyButton = styled.button`
    width: 100px;
    height: 41px;
    justify-self: flex-end;
    color: #fff;
    border: none;

    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    /* identical to box height */

    background-color: #FF5656;
    box-shadow: 0px 3px 8px rgba(130, 206, 94, 0.4);
    border-radius: 3px;

    &:hover {
      cursor: pointer;
      background-color: ${lighten(0.15, '#FF5656')};
    }

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    
  }
`


export const DivisionDiv = styled.div`
  width: 200px;
  /* border: 1px solid red; */
`
export const GI1 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-end;
  div {
    width: 48%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`
export const GI2 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-end;

  div {
    width: 30%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`


export const GI5 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;

  div {
    width: 22%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`
export const CI1 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-end;
  div {
    width: 30%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`


export const CI2 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;

  div {
    width: 22%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`
export const CI3 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  align-items: flex-end;
  margin-top: 10px;
  
  div:nth-child(1) {
    width: 74%
  }

  div:nth-child(2) {
    width: 22%
  }
  
  @media (max-width: 760px) {
      flex-direction: column;
      /* height: 160px; */
      margin-top: 10px;
      div:nth-child(1) {
        width: 100%
      }

    div:nth-child(2) {
      width: 100%
    }
  }
`

export const JA1 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;

  div {
    width: 48%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`

export const JA2 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  align-items: flex-end;
  margin-top: 10px;
  
  div:nth-child(1) {
    width: 74%
  }

  div:nth-child(2) {
    width: 22%
  }
  
  @media (max-width: 760px) {
      flex-direction: column;
      /* height: 160px; */
      margin-top: 10px;
      div:nth-child(1) {
        width: 100%
      }

    div:nth-child(2) {
      width: 100%
    }
  }
`

export const JA3 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;

  div {
    width: 22%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`
export const IT1 = styled.div`
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-end;

  div {
    width: 22%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`

export const PrintDiv = styled.div`
display: flex;
justify-content: flex-end;
margin-top: 5px;

&:hover {
  cursor: pointer;
}
`

export const PdfGenerateDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-start;
  div {
    width: 48%;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`

export const PdfGenerateDivTable = styled.div`
  display: flex;
  justify-content: flex-start;
  /* border: 1px solid red; */
  margin-top: 10px;
  align-items: flex-start;

  table {
    border: 0.5px solid #618095;
    text-align: center;
    width: 95%;
  }
  th {
    border: 0.5px solid #618095;
  }
  tr {
    border: 0.5px solid #618095;
  }
  td {
    padding: 5px;
    border: 0.5px solid #618095;
    max-width: 160px;
    max-height: 20px;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`

export const CheckBoxesDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  height: 400px;

  > div:nth-of-type(2) {
    display: flex;
    /* border: 1px solid red; */
    flex-direction: row;
    flex-wrap: wrap;

    div {
      width: 50%;
    }
  }

  @media (max-width: 760px) {
      flex-direction: column;
      div {
        width: 100%;
      }
    }
`